'use client'

import { useState } from 'react'
import { sanitizeHTML } from "@/lib/utils";

interface FrequentlyAskedQuestionsData {
  heading?: {
    text?: string;
    title?: string;
  };
  content_collection?: {
    id: string;
    site_content_collections_id: {
      collection: {
        item: {
          title: string;
          text: string;
        };
      }[];
    };
  }[];
}

export const fields = [
  // heading
  "heading.text",
  "heading.title",
  
  // content collection / FAQs
  "content_collection.id",
  "content_collection.site_content_collections_id.collection.item:site_content.title",
  "content_collection.site_content_collections_id.collection.item:site_content.text",
] as const;

interface FrequentlyAskedQuestionsProps {
  data?: FrequentlyAskedQuestionsData;
}

export default function FrequentlyAskedQuestions({ data }: FrequentlyAskedQuestionsProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section className="w-full bg-[#193762]">
      <div className="w-full max-w-[1464px] mx-auto px-8 py-12 md:py-24 md:px-16">
        <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-white mb-[19px] md:mb-12">
          {data?.heading?.title || "FAQs:"}
        </h2>
        
        <div className="flex flex-col gap-[26px] md:gap-9 w-full">
          {data?.content_collection?.map((collection, index) => {
            const titleItem = collection?.site_content_collections_id?.collection.find(
              item => item.item.title
            )?.item;
            
            const textItem = collection?.site_content_collections_id?.collection.find(
              item => item.item.text
            )?.item;

            const question = titleItem?.title || "";
            const answer = textItem?.text || "";
            
            return (
              <div key={collection.id} className="flex flex-col">
                <h3 className="text-3xl xl:text-4xl font-essonnes font-light text-white leading-[37.8px] md:leading-[54.4px] tracking-tight">
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex justify-between items-start gap-6 text-left group"
                    aria-expanded={openIndex === index}
                    aria-controls={`faq-answer-${collection.id}`}
                  >
                    <span className="flex-1">{question}</span>
                    <span className="w-8 h-8 flex items-center justify-center mt-1 flex-shrink-0">
                      <span className="text-white text-2xl font-light">
                        {openIndex === index ? '−' : '+'}
                      </span>
                    </span>
                  </button>
                </h3>
                
                <div
                  id={`faq-answer-${collection.id}`}
                  className={`grid transition-all duration-300 ease-in-out overflow-hidden ${
                    openIndex === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className={`overflow-hidden ${openIndex === index ? 'mt-6 md:mt-6 mb-6' : ''}`}>
                    <div
                      className="text-white text-[1rem] font-normal leading-normal md:text-xl font-greycliff md:leading-7 tracking-tight [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal md:[&>*]:text-xl md:[&>*]:leading-7 [&_a]:underline hover:[&_a]:no-underline"
                      dangerouslySetInnerHTML={sanitizeHTML(answer)}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )
} 